import { cloneDeep } from 'lodash';
const SET_CREDIT_VIEW_DEFAULT = 'SET_CREDIT_VIEW_DEFAULT';
const SET_CREDIT_VIEW_ACCEPT = 'SET_CREDIT_VIEW_ACCEPT';
const SET_CREDIT_VIEW_DECLINE = 'SET_CREDIT_VIEW_DECLINE';
const CREDIT_VIEW_DEFAULT = 'default';
const CREDIT_VIEW_ACCEPT = 'accept';
const CREDIT_VIEW_DECLINE = 'decline';

const initialState = CREDIT_VIEW_DEFAULT;

export default function reducer(state = cloneDeep(initialState), action) {
	switch (action.type) {
		case SET_CREDIT_VIEW_DEFAULT:
			return CREDIT_VIEW_DEFAULT;
		case SET_CREDIT_VIEW_ACCEPT:
			return CREDIT_VIEW_ACCEPT;
		case SET_CREDIT_VIEW_DECLINE:
			return CREDIT_VIEW_DECLINE;
		default:
			return state;
	}
}

export function setCreditViewDefault(){
	return { type: SET_CREDIT_VIEW_DEFAULT }
}

export function setCreditViewAccept(){
	return { type: SET_CREDIT_VIEW_ACCEPT }
}

export function setCreditViewDecline(){
	return { type: SET_CREDIT_VIEW_DECLINE }
}


// WEBPACK FOOTER //
// ./src/modules/credit_view.js